import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'

@Component({
  selector: 'app-veteran-center',
  templateUrl: './veteran-center.component.html',
  styleUrls: ['./veteran-center.component.css']
})
export class VeteranCenterComponent implements OnInit {
  
 

  public isVeteran;

  public account_id = [];
  public group_name = [];
  public selected;
  public siteDetails = [
    {site_id: 'site1', site_name: 'VLP'},
    {site_id: 'site2', site_name: 'RMU'}

  ];

 

  public veteranData;

  constructor(
    public dialogRef: MatDialogRef<VeteranCenterComponent>,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.veteranData = data;
  }

  ngOnInit(): void {

    if(this.veteranData.action == "veteran"){
      this.isVeteran = true;
    } else{
      this.isVeteran = false;
    }

  }

  selectCategory(selected, site_id, site_name, event) {
      this.selected = selected;
      this.account_id = site_id;
      this.group_name = site_name
  }

  onSubmit(){
    this.router.navigate(['/schedule-appointment']);
    this.dialogRef.close({
      event: 'veteran',
      // isUpdated: true
    })
  }



}
